import { Dispatch } from "redux"
import { ValidationError } from "sequelize"
import {
    CcRequirementRevision,
    CcRequirementRevisionSave,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import {
    LangType,
    RequirementRevisionValidation,

    LoadCcRequirementState,
    LoadCcRequirementHistory,
    LoadCcRequirementTempAnswers,

    setCcRequirementStateList,
    setCcRequirementHistoryList,
    setCcRequirementTempAnswerList,
} from "client/store"

export const LoadCcRequirementRevisionData = (
    requirementId: number,
    revisionId: number,
    dispatch: Dispatch,
) => (
    Promise.all([
        LoadCcRequirementState(requirementId, revisionId).then((res) => {
            dispatch(setCcRequirementStateList(requirementId, res))
        }),
        LoadCcRequirementHistory(requirementId, revisionId).then((res) => {
            dispatch(setCcRequirementHistoryList(requirementId, res))
        }),
        LoadCcRequirementTempAnswers(requirementId, revisionId).then((res) => {
            dispatch(setCcRequirementTempAnswerList(requirementId, res))
        }),
    ])
)
export const LoadCcRequirementRevisions = (requirementId: number) => (
    GET(`/ccRequirementRevision/requirement/${requirementId}`)
    .then((revisions: CcRequirementRevision[]) => revisions)
)
export const CreateCcRequirementRevision = (requirementId: number) => (
    GET(`/ccRequirementRevision/create/requirement/${requirementId}`)
    .then((revision: CcRequirementRevision) => revision)
)
export const UpdateCcRequirementRevision = (id: number, name: string, lang: LangType) => {
    const data: CcRequirementRevisionSave = { id, name }
    return POST(
        "/ccRequirementRevision/update",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        const validation = <RequirementRevisionValidation>validate(error, lang)

        return validation
    })
}
export const DeleteCcRequirementRevision = (revisionId: number) => (
    DELETE(`/ccRequirementRevision/delete/${revisionId}`)
    .then((removedRows: number) => removedRows)
)
